import React from 'react';
import './RMSHero.css';
import { useNavigate } from 'react-router-dom';

const RMSHero = () => {
  const navigate = useNavigate();
    const heroImage = process.env.PUBLIC_URL + 'assets/restorant.jpg'; // Replace with your actual public URL
    const handleDemoButtonClick = () => {
      document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
    };
    const navigateToGSTBill = () => {
      //navigate('/gst-bill');
      window.location.href = process.env.PUBLIC_URL + '/RMS/gst_bill.html';
    };

    return (
      <div className="RMShero-container">
      <div className="RMShero-text">
        <h1>Restaurant POS Software Made Simple!</h1>
        <p>Manages all your restaurant operations efficiently so that you can focus on growing your brand, like a real boss!</p>
        <button className="demo-button" onClick={handleDemoButtonClick}>Take a Free Demo</button>
        <button className="GST Bill" onClick={navigateToGSTBill}>GST Bill</button>
      </div>
      <div className="RMShero-image">
        <img src={heroImage} alt="Restaurant POS Software" />
      </div>
      </div>
    );
};

export default RMSHero;